import Client from './ClientOld';
import config from '../proxy/config';

/**
 * 埋点上报:统一封装原生的 logScreenView / logEvent 两个桥接方法。
 *
 *   import { logScreenView, logEvent } from '@/utils/tracker';
 *
 *   logScreenView('h5_flow_home');                                        // 页面进入
 *   logEvent({ eventId: 'click_h5_buy', params: { name: 'flow_pkg' } });  // 自定义事件,params 可省略
 *
 * 开发模式(REACT_APP_API_MODE=proxy,即 craco start 起的浏览器调试,没有原生壳)下不调桥,只打印。
 */

const IS_WEB_DEBUG = config.mode === 'proxy';

/**
 * Android 的桥是 JavascriptInterface,只接基本类型 —— 对象传过去在原生侧会变成 null,
 * 所以对象统一 JSON.stringify 后再过桥(字符串入参如页面名本来就合法,原样透传,不再套一层引号)。
 * iOS 的 WebViewJavascriptBridge 自己会做 JSON 序列化,不需要处理。
 */
const toBridgeParam = (payload) => {
  if (Client.clientType !== 'Android' || typeof payload === 'string' || payload == null) {
    return payload;
  }
  return JSON.stringify(payload);
};

const report = (type, payload) => {
  if (IS_WEB_DEBUG) {
    console.log(`[track] ${type}`, payload);
    return;
  }

  // getApi 是 async 方法 —— 同步异常也会变成 rejected promise,所以一处 catch 即可兜住,
  // 埋点失败只打 warning,不会冒到调用方的业务代码里
  Client.getApi(type, toBridgeParam(payload)).catch((err) => {
    console.warn(`[track] ${type} 上报失败,已忽略`, err);
  });
};

/**
 * 页面进入埋点
 * @param {string|{screenName: string}} screen 页面名,如 'h5_flow_home'
 */
export const logScreenView = (screen) => report('logScreenView', screen);

/**
 * 自定义事件埋点
 * @param {{eventId: string, params?: Object}} payload 事件参数,params 可省略
 */
export const logEvent = (payload) => report('logEvent', payload);
